// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__8zOCN","main":"MainLayout_main__Vf0li","container":"MainLayout_container__CNKEC"};